import { jsx as o } from "react/jsx-runtime";
import { cn as a } from "../../../lib/utils.js";
import h from "./OrderPreview.js";
import { memo as n } from "react";
import "../../../extend-tailwind-merge-e63b2b56.js";
import "../../../components/ui/progress.js";
import "../../../index-1c873780.js";
import "../../../index-563d1ed8.js";
import "../../../index-c8f2666b.js";
import "../../../_commonjsHelpers-10dfc225.js";
import "../../../lib.js";
import "../../../store/useStore.js";
import "../../../index-9d43cc8b.js";
import "../../../store/createTokenSearchSlice.js";
import "../../../immer-548168ec.js";
import "../../../store/createWalletSlice.js";
import "../../../store/createSwapSettingsSlice.js";
import "../../../store/createGlobalSettingsSlice.js";
import "../../../store/createUserOrdersSlice.js";
import "../../../store/createSwapSlice.js";
import "../../../store/createChartSlice.js";
import "../../../store/createBasketSlice.js";
import "../tokens.js";
import "../../../store/createModalWhatsNewSlice.js";
import "../../../store/createSwapParamsSlice.js";
import "../../../utils/formatNumber.js";
import "../../../components/ui/tooltipDialog.js";
import "../../../hooks/useScreen.js";
import "../../../components/ui/dialog.js";
import "../../../index-840f2930.js";
import "../../../index-c7156e07.js";
import "../../../index-4914f99c.js";
import "../../../index-67500cd3.js";
import "../../../index-27cadef5.js";
import "../../../index-5116e957.js";
import "../../../components/ui/tooltip.js";
import "../../../index-0ce202b9.js";
import "../../../index-bcfeaad9.js";
import "../../../index-f7426637.js";
import "../../../assets/svg/IconSquareInfo.js";
import "../../../x-9e07c78a.js";
import "../../../createLucideIcon-7a477fa6.js";
const c = ({
  dexes: p,
  dexSplits: i,
  possibleSplits: m
}) => {
  const s = i.reduce((t, r) => t + r.amount_in, 0);
  return /* @__PURE__ */ o(
    "div",
    {
      className: a(
        "dhs-grid dhs-grid-cols-2 dhs-gap-6 dhs-gap-y-2 dhs-leading-normal dhs-font-proximaMedium dhs-h-[106px] dhs-overflow-y-auto"
      ),
      children: Object.entries(p).map(([t, r], e) => {
        const d = i.find((l) => l.dex === t);
        return /* @__PURE__ */ o(
          "div",
          {
            className: "dhs-col-span-1 dhs-flex dhs-flex-col dhs-gap-3.5 dhs-text-sm",
            children: /* @__PURE__ */ o(
              h,
              {
                split: d,
                dex: r,
                totalAmount: s,
                possibleSplit: m[t],
                side: e % 2 === 0 ? "left" : "right"
              }
            )
          },
          t
        );
      })
    }
  );
}, ot = n(c);
export {
  ot as default
};
